<template>
  <div class="def-empty">
    <DefTrackingClick @close="$emit('close', $event)">
      <slot />
    </DefTrackingClick>
  </div>
</template>

<script>
import DefTrackingClick from '@components/Def/DefTrackingClick/DefTrackingClick.vue';

export default {
  name: 'DefEmpty',
  components: {
    DefTrackingClick,
  },
  props: ['result'],
};
</script>

<style lang="scss" scoped>
.def-empty {
  position: relative;
  :deep(.def-tracking-click) {
    font-weight: 500;
    font-size: rem(14);
    line-height: 125%;
    position: absolute;
    top: calc(100% + 10px);
    right: 0;
    width: 180px;
    padding: 12px 16px;
    background-color: #f6f6f6;
    z-index: 10001;
    &::before {
      content: '';
      border-left: 8px solid transparent;
      border-right: 8px solid #f6f6f6;
      border-top: 5px solid transparent;
      border-bottom: 5px solid #f6f6f6;
      display: block;
      position: absolute;
      top: 0;
      right: 10px;
      transform: translateY(-100%);
    }
  }
}
</style>
